import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const PolygonToolIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
          x="0.25"
          y="0.75"
          width="17.5"
          height="17.5"
          rx="0.75"
          stroke="white"
          strokeOpacity="0.5"
          strokeWidth="0.5"
          strokeDasharray="2 2"
        />
        <path
          d="M14.4121 7.74121L12.3447 14.1045H5.65527L3.58691 7.74121L9 3.80859L14.4121 7.74121Z"
          fill="#6DDAE2"
          fillOpacity="0.32"
          stroke="#19CAD7"
          strokeWidth="0.5"
        />
      </svg>
    </SvgIcon>
  );
};

export default PolygonToolIcon;
